import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { breadcrumbSchema } from '../utils/schemas';
import { Newspaper } from 'lucide-react';

const Changelog = () => {
  const entries = [
    {
      date: 'April 2026',
      items: [
        'Enhanced SEO and crawlability across all pages',
        'Added LLM discovery files (llms.txt)',
        'AndGo ecosystem cross-links added to footer',
      ],
    },
    {
      date: 'March 2026',
      items: [
        'Launched 15 Costco warehouse location pages',
        'Added property market snapshots with suburb-level data',
        'New loan calculators page',
        'Location pages for all 8 capital cities',
      ],
    },
    {
      date: 'February 2026',
      items: [
        'Costco partnership launched — exclusive rates for Executive Members',
        'New service pages: Asset Finance, Personal Loans, Car Loans',
        'Mobile-responsive redesign',
      ],
    },
    {
      date: 'January 2026',
      items: [
        'Platform launch with home loans, refinancing, and investment property pages',
        'Integration with SignAndGo for electronic document signing',
        'Contact form with reCAPTCHA protection',
      ],
    },
  ];

  const schema = breadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Changelog', url: '/changelog' },
  ]);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Changelog"
        description="See what's new at Manage Your Loans. Recent updates, new features, and improvements to our platform and services."
        path="/changelog"
        schema={schema}
      />
      <Navigation />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-[#00594C] to-[#003d35] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6">
              <Newspaper className="w-8 h-8 text-[#99DF63]" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">What's New</h1>
            <p className="text-lg text-gray-200">
              Recent updates and improvements to Manage Your Loans
            </p>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="relative">
              {/* Vertical line */}
              <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gray-200" />

              <div className="space-y-10">
                {entries.map((entry, index) => (
                  <div key={index} className="relative pl-10">
                    {/* Timeline dot */}
                    <div className="absolute left-0 top-1.5 w-[15px] h-[15px] rounded-full bg-[#00594C] border-4 border-white ring-2 ring-[#00594C]/20" />

                    <h2 className="text-xl font-bold text-[#00594C] mb-4">{entry.date}</h2>
                    <ul className="space-y-3">
                      {entry.items.map((item, itemIndex) => (
                        <li
                          key={itemIndex}
                          className="flex items-start text-gray-600 leading-relaxed"
                        >
                          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#99DF63] mt-2 mr-3 flex-shrink-0" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Changelog;
